/**
 * @format
 */
import { api } from '@/scripts/api';

export const SolutionService = {
    get(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Solutions';
            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `Id eq ${id}`,
            });

            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getFromOpportunity(dealId, config = {}) {
        return new Promise((resolve, reject) => {
            let expandParam =
                '$expand=LineItems($expand=Solution($expand=Bundles($select=Id,Name,Description,ImageUrl,Price,Quantity,FileMimeType))';
            let filterParam = config.search
                ? `;$filter=DealId eq ${dealId} and contains(Solution/Name, '${encodeURIComponent(
                      config.search
                  )}')`
                : '';
            let sortParam = config.sort
                ? `;$orderby=Solution/${config.sort.property} ${config.sort.direction}`
                : '';
            const service = `/service/Deals?${expandParam}${sortParam}${filterParam})&$filter=Id eq ${dealId}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getAll(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Solutions';
            const endpoint = api.applyODataParams(service, config);

            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    post(payload) {
        return new Promise((resolve, reject) => {
            api.post('/api/Solutions', payload).then(resolve).catch(reject);
        });
    },

    patch(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/Solutions/${id}`;

            api.patch(service, payload).then(resolve).catch(reject);
        });
    },

    delete(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/Solutions/${id}`;

            api.delete(service).then(resolve).catch(reject);
        });
    },

    deleteAll(ids) {
        return new Promise((resolve, reject) => {
            api.delete('/api/Solutions', ids).then(resolve).catch(reject);
        });
    },

    duplicate(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/Solutions/${id}/duplicate`;

            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    publish(id, clientIds) {
        return new Promise((resolve, reject) => {
            const service = `/api/Solutions/${id}/Publish`;

            api.post(service, clientIds).then(resolve).catch(reject);
        });
    },

    unpublish(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/Solutions/${id}/Publish`;

            api.post(service, []).then(resolve).catch(reject);
        });
    },

    getSharedAssets(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/SharedAssets';
            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `SolutionId eq ${id}`,
            });

            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getClients(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Clients';
            const endpoint = api.applyODataParams(service, config);

            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    addToMySolutions(accountId, id) {
        return new Promise((resolve, reject) => {
            const service = `/api/Accounts/${accountId}/Solutions/${id}/Add`;
            api.post(service).then(resolve).catch(reject);
        });
    },

    getSolutionTypeOptions(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/SolutionTypes';
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getBillingTypeOptions(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/BillingTypes';
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint).then(resolve).catch(reject);
        });
    },
};
